import React, {useState} from "react";
import SelectDrop from '../IncidentsLog/SearchDrop'
import Btn_green from '../IncidentsLog/Btn'
import IncidentsLog_search from '../IncidentsLog/Search'
// import IncidentReport from "../Modal/IncidentReport";
import {BasicTable} from "../React Table/BasicTable";
import IncidentReport from "../Modal/IncidentReport";
const Table = (props) => {
    const {setSelectedCourse,courses,selectedCourse,searchKey,setSearchKey,incidents}= props

    return (
        <>
            <div className="table">
                <div className="incident__wrapper">

                <h1 className="table-title">INCIDENTS LOG</h1>
                    {/*<IncidentReport />*/}
                    <IncidentReport/>

                </div>

                {/*<BasicTable />*/}

                <div className="table__head">
                    <IncidentsLog_search searchKey={searchKey} setSearchKey={setSearchKey} />
                    <Btn_green
                        incidents={incidents}

                    />
                    <SelectDrop style1={true} selectedCourse={selectedCourse} setSelectedCourse={setSelectedCourse} courses={courses} />
                </div>


            </div>


        </>
    );
};
export default Table;
